
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/contracts/violations",
      function () {
        return require("private-next-pages/events/contracts/violations.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/contracts/violations"])
      });
    }
  